import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import React from "react";
export default function WhatDefinesUs() {
  return <section data-section-id="221445" id="about" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          <div className="order-1">
            <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">相談室紹介</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">心に抱えた不安や悩みを<br />受け止め、和らげていく</h2>
            <Separator className="w-12 h-0.5 bg-primary mb-8" />
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed font-default">【新宿四谷 心理カウンセリングルーム】は曙橋・四谷エリアにある予約制の相談機関です。対面またはオンラインでメンタルヘルスに関するカウンセリングを行っています。カウンセリングとは、対話をしながら抱えている悩みや困りごとを解決していく方法です。</p>
              <p className="text-foreground leading-relaxed font-default">カウンセリングを行う理由は十人十色。「人間関係に悩んでいる」「仕事がうまくいかない」「勉強が手につかない」など、どんなご相談でも大丈夫です。ちょっとした悩みでも、抱えるのが大変な悩みでも、お気軽にご相談ください。</p>
              <p className="text-foreground leading-relaxed font-default">自分の悩みにカウンセリングが適当か分からない場合でもまずはお問い合せいただけたらと思います。</p>
            </div>
            <div className="pt-8">
              <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
                <Link to="https://yotsuya-sc-room.com/about/">相談室について詳しく見る</Link>
              </Button>
            </div>
          </div>

          <div className="order-2">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/4316b7772533335d6bc80479486df006-scaled-e1791041892634.jpg" alt="向かい合って置かれた2脚の椅子と植物" className="w-full rounded-lg shadow-lg object-cover aspect-[4/3]" loading="lazy" />
          </div>

        </div>
      </div>
    </section>;
}